export default function (context, val) {
    let settings = context.rootState.user.setting.items;
    context.dispatch('set_title', 'Добавление счета',{root:true});
    context.commit('set_load', {
        data: false,
    });
    let date = new Date();
    context.commit('set_form', {
        Id: 0,
        CertificateId: '',
        CertificateName: '',
        Name: '',
        NameLat: '',
        PaymentDirection: 1,
        PaymentOperationID: settings.DefaultRegularPaymentOperation,
        RateArticleId: null,
        CategoryId: context.rootGetters['dictionary/paymentType/getById'](settings.DefaultRegularPaymentType).CategoryId,
        PaymentTypeId: settings.DefaultRegularPaymentType,
        CashId: settings.DefaultRegularPaymentSource,
        PaymentAccountId: settings.DefaultRegularPaymentSource,
        AccountNumber: '',
        ContragentType: context.rootGetters['dictionary/contragentType/list'](settings.DefaultRegularPaymentOperation)[0].value,
        ContragentID: null,
        ContragentName: '',
        PartnerLegalEntityId: null,
        Sum: 0,
        CurrencyId: 1,
        PaymentDate: '',
        DocumentNumber: context.state.system.OutcomePaymentNumber,
        Comment: '',
        RegularPaymentTypeId: 4,
        dayMonth: 1,
        dayWeek: 1,
        NeedToPayDate: '' + (date.getDate() > 9 ? '' : '0' ) + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0' ) + (date.getMonth() + 1) + '.' + date.getFullYear(),
        AccountDate: '' + (date.getDate() > 9 ? '' : '0' ) + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0' ) + (date.getMonth() + 1) + '.' + date.getFullYear(),
        CreatedDate: '' + (date.getDate() > 9 ? '' : '0' ) + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0' ) + (date.getMonth() + 1) + '.' + date.getFullYear(),
        dayYear: '' + (date.getDate() > 9 ? '' : '0' ) + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0' ) + (date.getMonth() + 1) + '.' + date.getFullYear(),
        dayOne: '' + (date.getDate() > 9 ? '' : '0' ) + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0' ) + (date.getMonth() + 1) + '.' + date.getFullYear(),
        NotificationsEndDate: '',
        AgreementCodes: [],
    });
    if (settings.DefaultRegularPaymentOperation === 0) {
        context.dispatch('change_PaymentDirection', 1);
    }
}